export type SetFilterValue = string | number

export interface SetFilterOption {
  label: string
  value: SetFilterValue
}

/** The ticked values; `null` means the filter is off. */
export type SetFilterModel = SetFilterValue[] | null

/** Ticks or unticks a value. Unticking the last one turns the filter off. */
export const toggleSetFilterValue = (
  model: SetFilterModel,
  value: SetFilterValue
): SetFilterModel => {
  const current = model ?? []
  const next = current.includes(value)
    ? current.filter((item) => item !== value)
    : [...current, value]

  return next.length > 0 ? next : null
}

/** A row passes when the filter is off or its value is ticked. */
export const passesSetFilter = (
  model: SetFilterModel,
  value: unknown
): boolean => model === null || model.includes(value as SetFilterValue)
